import moment from "moment";

const formatDateNumber = (date: any) => {
  return date ? moment(date).format("YYYY-MM-DD") : "";
};
export default formatDateNumber;
